import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import PageExperience from "../page-experience/PageExperience";
import { createPageIdentity } from "../page-experience/pageExperienceModel";

const loadLive = () => import("./myRoutineLiveAdapter");
const loadExample = () => import("./myRoutineExampleAdapter");
export default function MyRoutineWorkspace({ Experience = PageExperience }) {
  const auth = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const access = { status: auth.error ? "error" : auth.loading ? "pending" : auth.userData?.uid ? "permitted" : "denied",
    reason: "signed-out", retry: auth.refreshAuth };
  return <Experience identity={createPageIdentity({ accountId: auth.userData?.uid, routeId: "my-routine" })}
    access={access} loadLive={loadLive} loadExample={loadExample}
    returnTo={location.pathname + location.search + (location.hash || "")}
    onAccessAction={({ returnTo }) => navigate("/login?next=" + encodeURIComponent(returnTo))} />;
}
